<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="走进富尔菱" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-video">
          <!-- <div class="p-video"> -->
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
          <!-- </div> -->
        </div>

        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <!-- <p class="eTitle">关于我们</p> -->
            <p class="content">
              广州市富尔菱自动化系统有限公司成立于2010年，总部设立在广州黄埔区，分别在香港和华东设立分公司及办事处，公司集研发、设计、制造、安装、售后服务为一整体智能包装解决方案的集成商。
            </p>
            <p class="title mt-15">核心产品</p>
            <p class="content content-li">
              智能包装数字化软件平台，（含：生产管理MES系统，仓储管理（WMS)，监控调度（WCS），追溯系统、设备采集及监控（Scada)系统）
            </p>
            <p class="content content-li">
              智能包装：（含柔性输送系统、物流分拣、提升机、装箱机、仓储系统）
            </p>
            <p class="content content-li">
              机器人应用研发（含：傻瓜式机器人码垛系统，复合机器人系统，特种AGV机器人研发）
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.jpg" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>

        <div class="content-culture">
          <div class="go-in-title mb-10">企业文化</div>
          <!-- <h3>CULTURE</h3> -->
          <div class="culture-li"><span>企业愿景</span> 成为卓越的生产服务型企业</div>
          <div class="culture-li"><span>企业使命</span> 引领后包装行业进步</div>
          <div class="culture-li"><span>核心价值</span> 实事求是，锐意创新</div>
          <div class="culture-li"><span>服务理念</span> 客户至上，需求导向</div>
          <div class="culture-li"><span>工作理念</span> 承上启下，利益共同</div>
        </div>
        <!-- 公司荣誉 -->
        <div class="content-honor">
          <div v-if="dialogTableVisible" class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <div class="go-in-title" style="text-align: center">公司荣誉</div>
            <p>已获得授权专利100多项，其中包括发明专利、实用新型专利、软件著作权等</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor, index) in honorList" :key="index">
              <img
                v-lazy="honor.img"
                @click="
                  dialogTableVisible = true;
                  dialogUrl = honor.img;
                  dialogTitle = honor.name;
                "
              />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <div class="go-in-title" style="text-align: center">团队风采</div>
            <!-- <p>TEAM</p> -->
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team, index) in teamItem" :key="index">
              <div class="swiper-img" v-lazy:background-image="team.img"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <!-- <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>RARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner, i) in partnerImg" :key="i">
                <img v-lazy="partner.img" alt />
              </li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: true,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: require("../assets/img/video/fullinkVideo.mp4"), //url地址
            // src: "http://www.shkjem.com/video/kj.mp4", //url地址
          },
        ],
        //poster: "../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },

      honorList: [
        {
          name: "高新技术企业证书",
          key: 999,
          img: require("@/assets/img/honor/honor.png"),
        },
        {
          name: "创新型中小企业",
          key: 998,
          img: require("@/assets/img/honor/honor9.png"),
        },
        {
          name: "专精特新中小企业",
          key: 997,
          img: require("@/assets/img/honor/honor10.png"),
        },
      ],
      partnerImg: [
        { name: 1, img: require("@/assets/img/ourParter/p1.png") },
        { name: 2, img: require("@/assets/img/ourParter/p2.png") },
        { name: 3, img: require("@/assets/img/ourParter/p3.png") },
        { name: 4, img: require("@/assets/img/ourParter/p4.png") },
        { name: 5, img: require("@/assets/img/ourParter/p5.png") },
        { name: 6, img: require("@/assets/img/ourParter/p6.png") },
        { name: 7, img: require("@/assets/img/ourParter/p7.png") },
        { name: 8, img: require("@/assets/img/ourParter/p8.png") },
        { name: 9, img: require("@/assets/img/ourParter/p9.png") },
        { name: 10, img: require("@/assets/img/ourParter/p10.png") },
        { name: 11, img: require("@/assets/img/ourParter/p11.png") },
        { name: 12, img: require("@/assets/img/ourParter/p12.png") },
        { name: 13, img: require("@/assets/img/ourParter/p13.png") },
        { name: 14, img: require("@/assets/img/ourParter/p14.png") },
        { name: 15, img: require("@/assets/img/ourParter/p15.png") },
        { name: 16, img: require("@/assets/img/ourParter/p16.png") },
        { name: 17, img: require("@/assets/img/ourParter/p17.png") },
        { name: 18, img: require("@/assets/img/ourParter/p18.png") },
        { name: 19, img: require("@/assets/img/ourParter/p19.png") },
        { name: 20, img: require("@/assets/img/ourParter/p20.png") },
        { name: 21, img: require("@/assets/img/ourParter/p21.png") },
        { name: 22, img: require("@/assets/img/ourParter/p22.png") },
      ],
      teamItem: [
        { img: require("@/assets/img/team/team1.jpg") },
        { img: require("@/assets/img/team/team2.jpg") },
        { img: require("@/assets/img/team/team3.jpg") },
      ],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
    };
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // this.$http
    //   .all([
    //     this.$http.get("Honor/GetHonorAll"),
    //     this.$http.get("Enterprise/GetEnterpriseAll"),
    //     this.$http.get(`Team/GetTeamAll`),
    //     this.$http.get(`Course/GetCourseAll`),
    //   ])
    //   .then(
    //     this.$http.spread(
    //       (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
    //         // this.honorList = responseHonor.data;
    //         // this.partnerImg = responseEnterprise.data;
    //         this.teamItem = responseTeam.data;

    //         // var groupCount = Math.ceil(responseCourse.data.length / 2);
    //         // window.console.log(groupCount);
    //         // for (let i = 0; i < groupCount; i++) {
    //         //   let img2 = [];
    //         //   for (let j = 0; j < 2; j++) {
    //         //     if (responseCourse.data.length - 1 >= i * 2 + j) {
    //         //       img2.push(responseCourse.data[i * 2 + j]);
    //         //     }
    //         //   }
    //         //   this.courseList.push(img2);
    //         // }
    //         // window.console.log(this.courseList);
    //         this.loading = false;
    //       }
    //     )
    //   );
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.go-in-title {
  color: $themeColor;
  font-size: 34px;
  font-family: "阿里楷体";
  text-shadow: 1px 1px 2px rgb(255, 235, 51);
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      // 视频介绍
      .content-video {
        width: 1000px;
        margin: 0 auto;
        padding: 60px 0;
      }
      // 公司简介
      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 0 0 100px 0;
        // padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            @extend .go-in-title;
            font-size: 25px;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 18px;
            text-indent: 25px;
            line-height: 30px;
          }
          .content-li {
            &::before {
              content: " ";
              width: 10px;
              height: 10px;
              margin-right: 5px;
              display: inline-block;
              background: #1667a0;
              border-radius: 50%;
            }
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 20px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        row-gap: 10px;
        background-color: #c2daeb;
        .culture-li {
          // color: $themeColor;
          font-size: 26px;
          line-height: 1.8;
          @include row-c;
        }
        // p {
        //   color: #3c6088;
        //   font-size: 26px;
        //   padding: 5px 0;
        // }
        span {
          font-weight: 400;
          font-size: 22px;
          color: #fff;
          border-radius: 10px;
          background-color: #c2daeb;
          display: inline-block;
          // width: 100px;
          padding: 6px 10px;
          margin-right: 10px;
          box-sizing: border-box;
          // height: 50px;
          background: $themeColor;
          text-align: center;
          box-shadow: 2px 2px 4px 1px rgb(132, 132, 132);
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          // justify-content: flex-start;
          align-content: flex-start;
          row-gap: 15px;
          li {
            width: 320px;
            height: 220px;
            // margin: 0 0 10px 15px;
            cursor: pointer;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-family: "阿里楷体";
    padding: 10px 0;
  }
  h3 {
    font-size: 32px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  // width: 100%;
  // height: 100%;
  z-index: 10;
  // text-align: center;
  // padding-bottom: 20px;
  // padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>
